// extracted by mini-css-extract-plugin
module.exports = {"logo":"_pzDDL","discover":"_1CpPQt","email":"V7wTqy","brandLink":"_20S-Mv"};